// Generated by tools/gen-backend-hooks.ts — do not edit by hand.
// One hook per endpoint in backend/customersPage/.

import { makeBackendHook } from './_client'

export type { BackendQuery, TriggerOptions } from './_client'

/** POST /api/rpc/customersPage/addCustomer */
export const useAddCustomer = makeBackendHook('customersPage', 'addCustomer')

/** POST /api/rpc/customersPage/addCustomerEmail */
export const useAddCustomerEmail = makeBackendHook('customersPage', 'addCustomerEmail')

/** POST /api/rpc/customersPage/bulkUpdateCustomers */
export const useBulkUpdateCustomers = makeBackendHook('customersPage', 'bulkUpdateCustomers')

/** POST /api/rpc/customersPage/getCustomer */
export const useGetCustomer = makeBackendHook('customersPage', 'getCustomer')

/** POST /api/rpc/customersPage/getCustomerEmails */
export const useGetCustomerEmails = makeBackendHook('customersPage', 'getCustomerEmails')

/** POST /api/rpc/customersPage/getCustomerLabelData */
export const useGetCustomerLabelData = makeBackendHook('customersPage', 'getCustomerLabelData')

/** POST /api/rpc/customersPage/getCustomerMergePreview */
export const useGetCustomerMergePreview = makeBackendHook('customersPage', 'getCustomerMergePreview')

/** POST /api/rpc/customersPage/getCustomerMerges */
export const useGetCustomerMerges = makeBackendHook('customersPage', 'getCustomerMerges')

/** POST /api/rpc/customersPage/getCustomerSummaries */
export const useGetCustomerSummaries = makeBackendHook('customersPage', 'getCustomerSummaries')

/** POST /api/rpc/customersPage/mergeCustomers */
export const useMergeCustomers = makeBackendHook('customersPage', 'mergeCustomers')

/** POST /api/rpc/customersPage/postToteLabels */
export const usePostToteLabels = makeBackendHook('customersPage', 'postToteLabels')

/** POST /api/rpc/customersPage/removeCustomerEmail */
export const useRemoveCustomerEmail = makeBackendHook('customersPage', 'removeCustomerEmail')

/** POST /api/rpc/customersPage/setStoreLocator */
export const useSetStoreLocator = makeBackendHook('customersPage', 'setStoreLocator')

/** POST /api/rpc/customersPage/syncB2bWholesale */
export const useSyncB2bWholesale = makeBackendHook('customersPage', 'syncB2bWholesale')

/** POST /api/rpc/customersPage/undoCustomerMerge */
export const useUndoCustomerMerge = makeBackendHook('customersPage', 'undoCustomerMerge')

/** POST /api/rpc/customersPage/updateCustomer */
export const useUpdateCustomer = makeBackendHook('customersPage', 'updateCustomer')
